// src/store/index.js
import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

// +----------------------------------------------------------------------
// | Desc:【Vuex状态管理】统一管理应用状态
// +----------------------------------------------------------------------

// 创建 store
const store = new Vuex.Store({
  // +----------------------------------------------------------------------
  // | loginUser
  // +----------------------------------------------------------------------
  state: {
    user: {},
    carCount: {},
  },

  // +----------------------------------------------------------------------
  // | Mutations: 同步修改状态
  // +----------------------------------------------------------------------
  mutations: {
    //更新用户信息
    UPDATE_USER(state, newUser) {
      state.user = newUser;
    },
    //更新购物车
    UPDATE_TOAST_CAR(state, TOAST) {
      state.carCount = TOAST;
    },
  },
});

export default store;
